export default "__VITE_ASSET__NfQSxweJ__"